/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Header({ user, children }) {
  return (
    <MDBox position="relative" mb={5}>
      <Card
        sx={{
          position: "relative",
          mx: { xs: 1, sm: 3 },
          py: { xs: 2, sm: 2.5 },
          px: { xs: 2, sm: 2.5 },
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {user.name}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                {user.role}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={{ xs: 3, sm: 5 }}>{children}</MDBox>
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  user: {
    name: "User",
    email: "",
    role: "",
  },
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default Header;
